import history from "../history";
import {
  getAccessToken,
  setAccessToken,
  setRefreshToken,
  removeAccessToken,
  removeRefreshToken,
  getTokenAccessLevel,
  getTokenPermissions,
} from "common/auth/token";
import { FORBIDDEN, UNAUTHORIZED } from "common/api/httpCodes";
import client from "./client";
import { clearLangCode } from "common/storage";

const loginRequest = () => {
  return {
    type: "auth/LOGIN_REQUEST",
  };
};

const loginSuccess = (user) => {
  return {
    type: "auth/LOGIN_SUCCESS",
    payload: user,
  };
};

const loginFailure = (error) => {
  return {
    type: "auth/LOGIN_FAILURE",
    payload: error,
    error: true,
  };
};

const fetchedUserPermissions = (permissions) => {
  return {
    type: "auth/FETCHED_PERMISSIONS",
    payload: permissions,
  };
};

const authHydrated = () => {
  return {
    type: "auth/AUTH_HYDRATED",
  };
};

export const hydrateAuth = () => {
  return async (dispatch) => {
    const accessToken = getAccessToken();
    if (accessToken) {
      let tokenPermissions = [];
      try {
        tokenPermissions = getTokenPermissions();
        dispatch(fetchedUserPermissions(tokenPermissions));
      } catch (err) {
        console.error("Invalid token during hydrateAuth", err);
        return dispatch(authHydrated());
      }

      try {
        const user = await client.get("users/current");
        dispatch(loginSuccess(user));
        return dispatch(authHydrated());
      } catch (err) {
        if (
          err.response &&
          (err.response.status === FORBIDDEN ||
            err.response.status === UNAUTHORIZED)
        ) {
          return dispatch(logout());
        }
        dispatch(loginFailure(err));
        return dispatch(authHydrated());
      }
    } else {
      return dispatch(authHydrated());
    }
  };
};

export const login = (credentials, redirect) => {
  return async (dispatch) => {
    dispatch(loginRequest());
    try {
      const response = await client.post("token", {
        body: Object.assign({}, credentials, { scope: "admin" }),
      });
      setRefreshToken(response.refresh_token);
      setAccessToken(response.access_token);

      const user = await client.get("users/current");
      dispatch(loginSuccess(user));

      const tokenPermissions = getTokenPermissions();
      dispatch(fetchedUserPermissions(tokenPermissions));

      if (redirect) {
        return history.push(redirect);
      } else if (
        getTokenAccessLevel() === "admin" &&
        tokenPermissions.length > 0
      ) {
        const firstResource = tokenPermissions[0];
        const redirectString =
          firstResource.resourceType === "building"
            ? `/${firstResource.resourceType}/${firstResource.resourceId}/notifications`
            : `/${firstResource.resourceType}/${firstResource.resourceId}/offers`;
        setTimeout(() => {
          history.push(redirectString);
        }, 500);
      } else {
        return history.push("/");
      }
    } catch (err) {
      return dispatch(loginFailure(err));
    }
  };
};

export const logout = () => {
  return (dispatch) => {
    removeAccessToken();
    removeRefreshToken();
    clearLangCode();
    dispatch({ type: "auth/LOGOUT" });
    window.location.href = "/login";
  };
};
